<!-- Petite Bannière -->
<section id="page-header" class="for-usermenucontent" style="background-image:url('../../../assets/imgs/background_ticket.png');
   background-repeat:no-repeat;
  -webkit-background-size:cover;
  -moz-background-size:cover;
  -o-background-size:cover;
  background-size:cover;
  background-position:center; ">
  <div class="banner-img-wrapper flexible height-100 as-image bg-bluegrey">
  </div>

  <div class="container width-100 overlay flexible flexible-column flex-just-bet">
    <header class="text-center white " style="vertical-align: middle;">
      <span class="dot">{{getInitials(user.firstname+' '+user.lastname)}}</span>
      <div class="text-justify user-name" style="display: inline-block;vertical-align: middle;">
         <h2> {{user.firstname+' '+user.lastname}}</h2>
         <h6>Membre depuis le {{user.created_at | datefrench1}}</h6>
      </div>
    </header>
  </div>
</section>

<div class="container  flexible flexible-column" style="align-items: end;margin-top: 13px">
  <ul class="nav nav-tabs  billet-profil" role="tablist" style="width: 195px;border-bottom: none;">
    <li class="nav-item width-50">
      <a class="active padding-0-mini" id="tab1" data-toggle="tab" href="#monprofil-tab" style="color: black" role="tab">
        {{'front_account.my_profil'| translate}}
      </a>
    </li>
    <li class="nav-item width-50">
      <a class="padding-0-mini " id="tab2" data-toggle="tab" href="#mesbillets-tab" style="color: black" role="tab">
        {{'front_account.my_tickets'| translate}}
      </a>
    </li>
  </ul>
</div>

<div class="tab-content">
  <div class="tab-pane active" id="monprofil-tab" role="tabpanel">
    <app-profile [user]="user"></app-profile>
  </div>
  <div class="tab-pane" id="mesbillets-tab" role="tabpanel">
    <app-tickets [user]="user"></app-tickets>
  </div>
</div>
